import { getInstance as getBootstrap } from 'utils/bootstrap';

const bootstrap = getBootstrap();
const customRsvpFields = bootstrap.get('customRsvpFields');

const FIRST_NAME = 'first_name';
const LAST_NAME = 'last_name';
const EMAIL = 'email';

const STATIC_FIELDS = {
    [FIRST_NAME]: FIRST_NAME,
    [LAST_NAME]: LAST_NAME,
    [EMAIL]: EMAIL,
};

const CUSTOM_NODE = 'customNode';
const GUEST_FIELD = new RegExp('guest_');
const DIGIT_REGEXP = new RegExp('[0-9]+');

const MULTIPLE_OPERATOR_SEPARATOR = '||';
const MULTI_CHECKBOX = 'check_multi';

const SPECIAL_FIELD_FORMATTING = {
    [MULTI_CHECKBOX]: (value) => value && value.split(MULTIPLE_OPERATOR_SEPARATOR),
};

const tryParseStringToInt = (value) =>
    value && !window.isNaN(value) && !window.isNaN(parseInt(value, 10)) ? parseInt(value, 10) : value;

export const getFormattedFieldData = (rsvpField, value) => ({
    column_name: rsvpField.column_name,
    custom_question_id:
        typeof rsvpField.custom_question_id === 'string'
            ? tryParseStringToInt(rsvpField.custom_question_id)
            : rsvpField.custom_question_id,
    name: `Question: ${rsvpField.name}`,
    value: SPECIAL_FIELD_FORMATTING[rsvpField.type] ? SPECIAL_FIELD_FORMATTING[rsvpField.type](value) : value,
});

const getCustomRsvpField = (name, value) => {
    const customRsvpField = customRsvpFields.find((rsvpField) => rsvpField.column_name === name);
    return getFormattedFieldData(customRsvpField, value);
};

const getCustomNodeRsvpField = (key, value) => {
    const customRsvpField = customRsvpFields.find((rsvpField) => `${rsvpField._formBuilderNodeId}` === `${key}`);
    return {
        [customRsvpField.number]: getFormattedFieldData(customRsvpField, value),
    };
};

const getGuestFieldName = (fieldName) => Object.values(STATIC_FIELDS).find((keyName) => fieldName.includes(keyName));

const getFormattedGuestFields = (guests) =>
    Object.values(guests).reduce(
        (acc, next) => [
            ...acc,
            {
                name: `${next[FIRST_NAME]} ${next[LAST_NAME]}`,
                email: next[EMAIL],
            },
        ],
        [],
    );

export default function getMobileRsvpParams(params) {
    const {
        action,
        event_id, // eslint-disable-line camelcase
        payload,
    } = params;
    const parsedParams = JSON.parse(payload);
    const mobileParams = Object.entries(parsedParams).reduce((acc, [key, value]) => {
        if (STATIC_FIELDS[key]) {
            return {
                ...acc,
                [key]: value,
            };
        }

        // customNode goes here.
        if (key === CUSTOM_NODE) {
            const customNodes = Object.entries(value).reduce(
                (customNodeAcc, [nodeKey, nodeValue]) => ({
                    ...customNodeAcc,
                    ...getCustomNodeRsvpField(nodeKey, nodeValue),
                }),
                {},
            );
            return {
                ...acc,
                custom: customNodes,
            };
        }

        // For additional guest formatted fields.
        if (GUEST_FIELD.test(key)) {
            if (!value) {
                return acc;
            }

            const guestIdentifier = key.match(DIGIT_REGEXP);
            const guestFieldName = getGuestFieldName(key);
            const guests = acc.guests || {};
            if (guestIdentifier) {
                const guestId = guestIdentifier[0];
                return {
                    ...acc,
                    guests: {
                        ...guests,
                        [guestId]: {
                            ...(guests[guestId] || {}),
                            [guestFieldName]: value,
                        },
                    },
                };
            }
        }

        return {
            ...acc,
            [key]: getCustomRsvpField(key, value),
        };
    }, {});

    const guests = mobileParams.guests ? getFormattedGuestFields(mobileParams.guests) : [];

    return {
        ...mobileParams,
        action,
        event_id,
        attendee_count: guests.length,
        guests,
    };
}
